<ng-container *ngIf="control?.touched">
  <ng-container *ngIf="message">
    <p class="error-text">{{ message }}</p>
  </ng-container>
</ng-container>
